import Debug from 'debug';
import { ExamStateMachineData } from '../data'
import { ExamStateMachineAbstractState, ExamStateMachineCommonEvents } from './state';

const debug = Debug('exam-summary-state')

interface Events extends ExamStateMachineCommonEvents {
  onReset: () => void
  onReviewRequested: (questionIndex: number) => void
}

export class ExamSummaryState extends ExamStateMachineAbstractState<Events> {

  public readonly name = 'summary'

  constructor(private state: ExamStateMachineData) {
    super()
  }

  navigate(questionIndex: number) {
    this.triggerEvent(events => events.onReviewRequested(questionIndex))
  }

  enter() {
    debug('enter')
  }

  exit() {
    debug('exit')
  }

  cancel() {
    debug('cancel')
    this.beginCancel()
    this.endCancel()
  }

  reset() {
    debug('reset')
    this.triggerEvent(events => events.onReset())
  }
}
